import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import HomeLink from './HomeLink';

const Logo = ({ at = 'auth', width = 58, className, textClass, ...rest }) => {
  return (
    <HomeLink
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' },
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-4 mb-4': at === 'auth',
          },
          className,
        )}
      >
        {/*<img className="me-2" src={logo} alt="Logo" width={width} />*/}
        <span className={classNames('font-sans-serif', textClass)}>
          WMS
          {process.env.NODE_ENV === 'development' && (
            <span
              className="ms-1 badge bg-danger"
              style={{ fontSize: '0.5em', verticalAlign: 'super' }}
            >
              DEV
            </span>
          )}
        </span>
      </div>
    </HomeLink>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
};

export default Logo;
